import { useEffect, useState, useRef } from "react";
import styles from "./VideoModal.module.css";

interface VideoModalProps {
  videoId: string;
  onClick: () => void;
}

export default function VideoModal({ videoId, onClick }: VideoModalProps) {
 
  return (
    <div className={styles.modal} onClick={onClick}>
    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
      <iframe
        width="100%"
        height="400"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allowFullScreen
      ></iframe>
    </div>
  </div>
  );
}
